module.exports = __webpack_public_path__ + "img/lobby_lounge.e0e94d84.jpg";